import { appConfig } from '@/config/app.ts'
import { PayAllService } from '@/modules/services/payAll/types/PayAllService.ts'

export interface PayAllState {
  filters: string
  editService: PayAllService | null
}

export const initialState: PayAllState = {
  filters: `?limit=${appConfig.pagination.defaultValue}`,
  editService: null
}
